import { render } from "./UbmChat.vue?vue&type=template&id=1ed68d50&ts=true"
import script from "./UbmChat.vue?vue&type=script&lang=ts"
export * from "./UbmChat.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/chat/infrastructure/UbmChat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ed68d50"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ed68d50', __exports__)) {
    api.reload('1ed68d50', __exports__)
  }
  
  module.hot.accept("./UbmChat.vue?vue&type=template&id=1ed68d50&ts=true", () => {
    api.rerender('1ed68d50', render)
  })

}


export default __exports__